import(/* webpackMode: "eager" */ "/var/www/pinuprompt.site/src/app/not-found.tsx");
